export class ImportFormatExamples {
    public xmlFormatExample: string;
    public jsonFormatExample: string;
}
